export class VehiclePermit {
    validFrom = null;
    validTo = null;
    createdDate = new Date();
}
